import store from '@/store'
import { getTokenNode } from '@/store/utils/tokenNode'
import { decideRelease } from '@/services/releasePolicy'

const POLL_MS = 60000
let started = false
let checking = false

function runningRelease() {
  return {
    version: process.env.VUE_APP_VERSION || '',
    build: process.env.VUE_APP_BUILD || '',
  }
}

function remember(version, build) {
  if (version) localStorage.setItem('bc_version', version)
  localStorage.setItem('bc_build', build || '')
}

function navigate(version, build, toLogin) {
  const stamp = build || version
  sessionStorage.setItem('bc_release_applied', stamp)
  remember(version, build)
  const url = toLogin
    ? new URL('/login', window.location.origin)
    : new URL(window.location.href)
  url.searchParams.set('v', stamp)
  window.location.replace(url.toString())
}

function logoutThenLogin(version, build) {
  const finish = () => {
    const keptVersion = version
    const keptBuild = build || ''
    localStorage.clear()
    sessionStorage.clear()
    remember(keptVersion, keptBuild)
    sessionStorage.setItem('bc_release_applied', keptBuild || keptVersion)
    navigate(keptVersion, keptBuild, true)
  }
  store.dispatch('auth/logoutRequest').then(finish, finish)
}

export function applyReleaseDecision(decision) {
  if (!decision || decision.action === 'none') return
  if (decision.action === 'remember') {
    remember(decision.version, decision.build)
    return
  }
  if (decision.action === 'logout') {
    logoutThenLogin(decision.version, decision.build)
    return
  }
  navigate(decision.version, decision.build, false)
}

export async function checkRelease() {
  if (checking) return
  checking = true
  const running = runningRelease()
  let remote = null
  try {
    const response = await fetch(`/release.json?t=${Date.now()}`, {
      cache: 'no-store',
    })
    if (response.ok) remote = await response.json()
  } catch (error) {
    remote = null
  }

  if (
    remote &&
    remote.build &&
    remote.build === running.build &&
    remote.version === running.version
  ) {
    sessionStorage.removeItem('bc_release_applied')
  }

  const decision = decideRelease(running, remote, {
    storedVersion: localStorage.getItem('bc_version'),
    hasSession: Boolean(getTokenNode()),
    alreadyApplied: sessionStorage.getItem('bc_release_applied') || '',
  })
  checking = false
  applyReleaseDecision(decision)
}

export function startReleaseWatch() {
  if (started || typeof window === 'undefined') return
  started = true
  checkRelease()
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) checkRelease()
  })
  window.setInterval(checkRelease, POLL_MS)
}
